import { useState } from "react";

const PDFViewer = ({ pdfUrl }) => {
  console.log("PDFViewer rendered with pdfUrl:", pdfUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  if (!pdfUrl) {
    console.log("No pdfUrl provided, returning null");
    return null;
  }

  return (
    <div
      className="pdf-preview-container"
      style={{
        borderRadius: "8px",
        overflow: "hidden",
        padding: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        className="pdf-preview-header"
        style={{
          padding: "15px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "3.985px",
              height: "31.99px",
              backgroundColor: "#FBD880",
            }}
          ></div>
          <h3
            style={{
              margin: 0,
              color: "#333",
              fontSize: "18px",
              fontWeight: "600",
              fontFamily: "Lexend",
            }}
          >
            Preview
          </h3>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow:
                "0px 25px 3.5px rgba(135,135,135,0), 0px 16px 3px rgba(135,135,135,0.01), 0px 9px 2.5px rgba(135,135,135,0.05), 0px 4px 2px rgba(135,135,135,0.09), 0px 1px 1px rgba(135,135,135,0.1)",
            }}
            onClick={() => {
              const link = document.createElement("a");
              link.href = pdfUrl;
              link.download = "quality-report.pdf";
              link.click();
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 17V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V17M7 12L12 17M12 17L17 12M12 17V3"
                stroke="#0A0A0A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        className="pdf-preview-content"
        style={{
          height: "800px",
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        {/* Loading Spinner */}
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              zIndex: 10,
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                margin: "0 auto 10px",
              }}
            ></div>
            <p style={{ color: "#666", margin: 0 }}>Loading PDF...</p>
          </div>
        )}

        {/* Error Fallback */}
        {/* {hasError && (
          <div
            style={{
              position: "absolute",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              padding: "20px",
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              zIndex: 10,
            }}
          >
            <p style={{ marginBottom: "15px" }}>
              PDF preview may not be available in this browser.
            </p>
            <div
              style={{ display: "flex", gap: "10px", justifyContent: "center" }}
            >
              <button>
                <a
                  href={pdfUrl}
                  download="quality-report.pdf"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    padding: "8px 16px",
                    backgroundColor: "#28a745",
                    borderRadius: "4px",
                  }}
                >
                  📥 Download PDF
                </a>
              </button>
            </div>
          </div>
        )} */}

        {/* PDF Iframe - Direct embed for better styling control */}
        <iframe
          src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(pdfUrl)}`}
          style={{
            width: "90%",
            height: "100%",
            border: "none",
            borderRadius: "22px",
            padding: "10px",
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease-in-out",
          }}
          title="Quality Report PDF Preview"
          onLoad={() => {
            setIsLoading(false);
            setHasError(false);
          }}
          onError={() => {
            setIsLoading(false);
            setHasError(true);
          }}
        />

        {/* Add CSS animation for spinner */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default PDFViewer;

// import { useState, useCallback, useEffect } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const PDFViewer = ({ pdfUrl }) => {
//   console.log("PDFViewer rendered with pdfUrl:", pdfUrl);
//   const [numPages, setNumPages] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [hasError, setHasError] = useState(false);
//   const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

//   const onDocumentLoadSuccess = useCallback(({ numPages }) => {
//     setNumPages(numPages);
//     setIsLoading(false);
//     setHasError(false);
//   }, []);

//   const onDocumentLoadError = useCallback(() => {
//     setIsLoading(false);
//     setHasError(true);
//   }, []);

//   useEffect(() => {
//     if (!pdfUrl) return;
//     let blobUrl;
//     fetch(pdfUrl)
//       .then((res) => res.blob())
//       .then((blob) => {
//         blobUrl = URL.createObjectURL(blob);
//         setPdfBlobUrl(blobUrl);
//       })
//       .catch(() => setHasError(true));

//     return () => {
//       if (blobUrl) URL.revokeObjectURL(blobUrl); // ✅ uses local var, not stale state
//     };
//   }, [pdfUrl]);

//   if (!pdfUrl) {
//     console.log("No pdfUrl provided, returning null");
//     return null;
//   }

//   return (
//     <div
//       className="pdf-preview-container"
//       style={{
//         borderRadius: "8px",
//         overflow: "hidden",
//         padding: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       {/* Header */}
//       <div
//         className="pdf-preview-header"
//         style={{
//           padding: "15px",
//           display: "flex",
//           alignItems: "center",
//           gap: "10px",
//         }}
//       >
//         <div
//           style={{
//             width: "3.985px",
//             height: "31.99px",
//             backgroundColor: "#FBD880",
//           }}
//         />
//         <h3
//           style={{
//             margin: 0,
//             color: "#333",
//             fontSize: "18px",
//             fontWeight: "600",
//             fontFamily: "Lexend",
//           }}
//         >
//           Preview
//         </h3>
//       </div>

//       {/* PDF Content */}
//       <div
//         className="pdf-preview-content"
//         style={{
//           height: "800px",
//           position: "relative",
//           borderRadius: "22px",
//           overflow: "auto",
//           backgroundColor: "#f0f0f0", // 👈 your custom background color
//           padding: "10px",
//           boxSizing: "border-box",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//         }}
//       >
//         {/* Loading Spinner */}
//         {isLoading && (
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               textAlign: "center",
//               zIndex: 10,
//             }}
//           >
//             <div
//               style={{
//                 width: "40px",
//                 height: "40px",
//                 border: "4px solid #f3f3f3",
//                 borderTop: "4px solid #007bff",
//                 borderRadius: "50%",
//                 animation: "spin 1s linear infinite",
//                 margin: "0 auto 10px",
//               }}
//             />
//             <p style={{ color: "#666", margin: 0 }}>Loading PDF...</p>
//           </div>
//         )}

//         {/* Error State */}
//         {hasError && (
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               textAlign: "center",
//               padding: "20px",
//               backgroundColor: "white",
//               borderRadius: "8px",
//               boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//               zIndex: 10,
//             }}
//           >
//             <p style={{ marginBottom: "15px" }}>
//               PDF preview could not be loaded.
//             </p>
//           </div>
//         )}

//         {/* react-pdf Document */}
//         {pdfBlobUrl && (
//         <Document
//           file={pdfBlobUrl}
//           onLoadSuccess={onDocumentLoadSuccess}
//           onLoadError={onDocumentLoadError}
//           loading={null}
//         >
//           {Array.from({ length: numPages || 0 }, (_, i) => (
//             <Page
//               key={`page_${i + 1}`}
//               pageNumber={i + 1}
//               width={600}
//               style={{ marginBottom: "12px" }}
//               renderTextLayer={true}
//               renderAnnotationLayer={true}
//             />
//           ))}
//         </Document>
//         )}

//         <style>
//           {`
//             @keyframes spin {
//               0% { transform: rotate(0deg); }
//               100% { transform: rotate(360deg); }
//             }
//           `}
//         </style>
//       </div>
//     </div>
//   );
// };

// export default PDFViewer;
